import { Suspense, lazy } from "react";
import Authenticated from "src/components/Authenticated";
import PermissionGuard from "src/components/PermissionGuard";
import { Navigate } from "react-router-dom";
import SuspenseLoader from "src/components/SuspenseLoader";

import BoxedSidebarLayout from "src/layouts/BoxedSidebarLayout";
import DocsLayout from "src/layouts/DocsLayout";
import BaseLayout from "src/layouts/BaseLayout";
import AccentHeaderLayout from "src/layouts/AccentHeaderLayout";
import AccentSidebarLayout from "src/layouts/AccentSidebarLayout";
import ExtendedSidebarLayout from "src/layouts/ExtendedSidebarLayout";
import CollapsedSidebarLayout from "src/layouts/CollapsedSidebarLayout";
import BottomNavigationLayout from "src/layouts/BottomNavigationLayout";
import TopNavigationLayout from "src/layouts/TopNavigationLayout";
import MinipaySidebarLayout from "src/layouts/MinipaySidebarLayout";
import MinipayAuthenticated from "src/content/minipay/MinipayAuthenticated";
import { MinipayParticipantesProvider } from "src/content/minipay/MinipayParticipantesContext";
import { MinipayEventosProvider } from "src/content/minipay/MinipayEventosContext";

// import dashboardsRoutes from './dashboards'
// import blocksRoutes from './blocks'
// import applicationsRoutes from './applications'
import menuRoutes from "./menu";
import administrationRoutes from "./administration";
import managementRoutes from "./management";
import documentationRoutes from "./documentation";
import accountRoutes from "./account";
import baseRoutes from "./base";
import minipayRoutes from "./minipay";
import bertaRoutes from "src/content/berta/routes";
import { usePlanPermissions } from "src/hooks/usePlanPermissions";

const Loader = (Component) => (props) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

// TV 3.0 desligada para a conta (override do admin ou plano): o menu some e o
// endereço digitado direto volta para a home, como na Berta.
const Tv30Guard = ({ children }) => {
  const planPerms = usePlanPermissions();
  return planPerms.tv30 ? children : <Navigate to="/extended-sidebar/menu/home" replace />;
};
const Podcast = Loader(lazy(() => import("src/content/podcast")));
const PodcastListas = Loader(lazy(() => import("src/content/podcast/Listas")));
const StatusComingSoon = Loader(lazy(() => import("src/content/pages/Status/ComingSoon")));
const Relatorios = Loader(lazy(() => import("src/content/relatorios/relatorios")));
const RelatorioMensagens = Loader(lazy(() => import("src/content/relatorios/RelatorioMensagens")));
const RelatorioEngajamentoHorario = Loader(lazy(() => import("src/content/relatorios/RelatorioEngajamentoHorario")));
const BI = Loader(lazy(() => import("src/content/relatorios/BI")));
const Tv30 = Loader(lazy(() => import("src/content/tv30")));
const Tv30Config = Loader(lazy(() => import("src/content/tv30/Config")));
const Tv30Interatividade = Loader(lazy(() => import("src/content/tv30/Interatividade")));
const ImpersonationPage = Loader(lazy(() => import("src/content/suporte/ImpersonationPage")));
const SupportAccessPage = Loader(lazy(() => import("src/content/suporte/SupportAccessPage")));
const WikiList = Loader(lazy(() => import("src/content/wiki/WikiList")));
const WikiArticle = Loader(lazy(() => import("src/content/wiki/WikiArticle")));
const MinipayHome = Loader(lazy(() => import("src/content/minipay/Home/home")));
const MinipayParticipantes = Loader(lazy(() => import("src/content/minipay/Participantes")));
const MinipayEventos = Loader(lazy(() => import("src/content/minipay/Eventos")));
const MinipayEventoDetalhe = Loader(lazy(() => import("src/content/minipay/Eventos/EventoDetalhe")));
const MinipayConfiguracoes = Loader(lazy(() => import("src/content/minipay/Configuracoes")));

const router = [
  {
    path: "account",
    children: accountRoutes,
  },
  {
    path: "",
    element: <BaseLayout />,
    children: baseRoutes,
  },
  {
    path: "minipay",
    element: <BaseLayout />,
    children: minipayRoutes,
  },
  {
    path: "minipay/main",
    element: (
      <MinipayAuthenticated>
        <MinipayParticipantesProvider>
          <MinipayEventosProvider>
            <MinipaySidebarLayout />
          </MinipayEventosProvider>
        </MinipayParticipantesProvider>
      </MinipayAuthenticated>
    ),
    children: [
      { path: "", element: <MinipayHome /> },
      { path: "participantes", element: <MinipayParticipantes /> },
      { path: "eventos", element: <MinipayEventos /> },
      { path: "eventos/:id", element: <MinipayEventoDetalhe /> },
      { path: "configuracoes", element: <MinipayConfiguracoes /> },
    ],
  },

  // Rota standalone para troca de token de suporte (nova aba, sem layout)
  {
    path: "suporte/acesso",
    element: <ImpersonationPage />,
  },

  // Documentation
  {
    path: "docs",
    element: <DocsLayout />,
    children: documentationRoutes,
  },

  // Boxed Sidebar Layout
  {
    path: "boxed-sidebar",
    element: (
      <Authenticated>
        <BoxedSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="menu" replace />,
      },
      // {
      //   path: "dashboards",
      //   children: dashboardsRoutes,
      // },
      // {
      //   path: "blocks",
      //   children: blocksRoutes,
      // },
      // {
      //   path: "applications",
      //   children: applicationsRoutes,
      // },
      // {
      //   path: "management",
      //   children: managementRoutes,
      // },
      {
        path: "menu",
        children: menuRoutes,
      },
    ],
    adm: [
      {
        path: "administration",
        children: administrationRoutes,
      },
    ],
  },

  // Accent Sidebar Layout

  {
    path: "accent-sidebar",
    element: (
      <Authenticated>
        <AccentSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="menu" replace />,
      },
      // {
      //   path: "dashboards",
      //   children: dashboardsRoutes,
      // },
      // {
      //   path: "blocks",
      //   children: blocksRoutes,
      // },
      // {
      //   path: "applications",
      //   children: applicationsRoutes,
      // },
      // {
      //   path: "management",
      //   children: managementRoutes,
      // },
      {
        path: "menu",
        children: menuRoutes,
      },
      {
        path: "administration",
        children: administrationRoutes,
      },
    ],
  },

  // Collapsed Sidebar Layout

  {
    path: "collapsed-sidebar",
    element: (
      <Authenticated>
        <CollapsedSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="menu" replace />,
      },
      // {
      //   path: "dashboards",
      //   children: dashboardsRoutes,
      // },
      // {
      //   path: "blocks",
      //   children: blocksRoutes,
      // },
      // {
      //   path: "applications",
      //   children: applicationsRoutes,
      // },
      // {
      //   path: "management",
      //   children: managementRoutes,
      // },
      {
        path: "menu",
        children: menuRoutes,
      },
      {
        path: "administration",
        children: administrationRoutes,
      },
    ],
  },

  // Bottom Navigation Layout

  {
    path: "bottom-navigation",
    element: (
      <Authenticated>
        <BottomNavigationLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="menu" replace />,
      },
      // {
      //   path: "dashboards",
      //   children: dashboardsRoutes,
      // },
      // {
      //   path: "blocks",
      //   children: blocksRoutes,
      // },
      // {
      //   path: "applications",
      //   children: applicationsRoutes,
      // },
      // {
      //   path: "management",
      //   children: managementRoutes,
      // },
      {
        path: "menu",
        children: menuRoutes,
      },
      {
        path: "administration",
        children: administrationRoutes,
      },
    ],
  },

  // Top Navigation Layout

  {
    path: "top-navigation",
    element: (
      <Authenticated>
        <TopNavigationLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="menu" replace />,
      },
      // {
      //   path: "dashboards",
      //   children: dashboardsRoutes,
      // },
      // {
      //   path: "blocks",
      //   children: blocksRoutes,
      // },
      // {
      //   path: "applications",
      //   children: applicationsRoutes,
      // },
      // {
      //   path: "management",
      //   children: managementRoutes,
      // },
      {
        path: "menu",
        children: menuRoutes,
      },
      {
        path: "administration",
        children: administrationRoutes,
      },
    ],
  },

  // Accent Header Layout

  {
    path: "accent-header",
    element: (
      <Authenticated>
        <AccentHeaderLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="menu" replace />,
      },
      {
        path: "menu",
        children: menuRoutes,
      },

      // {
      //   path: "dashboards",
      //   children: dashboardsRoutes,
      // },
      // {
      //   path: "blocks",
      //   children: blocksRoutes,
      // },
      // {
      //   path: "applications",
      //   children: applicationsRoutes,
      // },
      // {
      //   path: "management",
      //   children: managementRoutes,
      // },
    ],
  },

  // Extended Sidebar Layout
  ///////// Layout Usado /////////

  {
    path: "extended-sidebar",
    element: (
      <Authenticated>
        <ExtendedSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="menu" replace />,
      },
      {
        path: "menu",
        children: menuRoutes,
      },
      {
        path: "administration",
        children: administrationRoutes,
      },
      {
        path: "administration/suporte/:hash",
        element: <SupportAccessPage />,
      },
      // {
      //   path: 'dashboards',
      //   children: dashboardsRoutes,
      // },
      // {
      //   path: "blocks",
      //   children: blocksRoutes,
      // },
      // {
      //   path: "applications",
      //   children: applicationsRoutes,
      // },
      {
        path: "management",
        children: managementRoutes,
      },
      // Berta (redação) — ponto único de montagem; páginas e guards em
      // src/content/berta/routes.js.
      {
        path: "berta",
        children: bertaRoutes,
      },
      {
        path: "podcast",
        element: <PermissionGuard permissionKey="robocast"><Podcast /></PermissionGuard>,
      },
      {
        path: "podcast/listas",
        element: <PermissionGuard permissionKey="robocast_listas"><PodcastListas /></PermissionGuard>,
      },
      {
        path: "tv30",
        element: <Tv30Guard><Tv30 /></Tv30Guard>,
      },
      {
        path: "tv30/interatividade",
        element: <Tv30Guard><Tv30Interatividade /></Tv30Guard>,
      },
      {
        path: "tv30/marketplace",
        element: <Tv30Guard><Tv30 /></Tv30Guard>,
      },
      {
        path: "tv30/pauta-extra",
        element: <Tv30Guard><Tv30 /></Tv30Guard>,
      },
      {
        path: "tv30/config",
        element: <Tv30Guard><Tv30Config /></Tv30Guard>,
      },
      {
        path: "relatorios",
        element: <PermissionGuard permissionKey="relatorios"><Relatorios /></PermissionGuard>,
      },
      {
        path: "relatorios/mensagens-recebidas",
        element: <PermissionGuard permissionKey="relatorios"><RelatorioMensagens /></PermissionGuard>,
      },
      {
        path: "relatorios/engajamento-horario",
        element: <PermissionGuard permissionKey="relatorios"><RelatorioEngajamentoHorario /></PermissionGuard>,
      },
      {
        path: "bi",
        element: <PermissionGuard permissionKey="bi"><BI /></PermissionGuard>,
      },
      {
        path: "bi",
        element: <BI />,
      },
      {
        path: "bi",
        element: <BI />,
      },
      {
        path: "bi",
        element: <BI />,
      },
      {
        path: "bi",
        element: <BI />,
      },
      {
        path: "bi",
        element: <BI />,
      },
      {
        path: "bi",
        element: <BI />,
      },
      {
        path: "bi",
        element: <BI />,
      },
    ],
  },

  // Wiki — público (sem Authenticated)
  {
    path: "extended-sidebar/wiki",
    element: <ExtendedSidebarLayout />,
    children: [
      { path: "", element: <WikiList /> },
      { path: ":slug", element: <WikiArticle /> },
    ],
  },
];

export default router;
